/** Global standard E.164 - general format for international telephone numbers */
// Increased the minimum number length to 4 digits to filter out very improbable numbers
const phoneRegexE164 = /^\+[1-9]\d{4,14}$/;

export const validatePhoneE164 = (phone: string | undefined): boolean => phoneRegexE164.test(phone ?? '');
